module.exports = __webpack_public_path__ + "img/1596168492.5f290a8f.jpg";